import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { PaginatedApiResponse } from '@wdx/clmi/api-services/models';
import { NudgeType } from '@wdx/clmi/clmi-swagger-gen';
import { Observable } from 'rxjs';
import { ConfigService } from '../../services/config.service';

@Injectable()
export class NudgeTypesService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    getAll(): Observable<PaginatedApiResponse<NudgeType>> {
        return this.http.get<PaginatedApiResponse<NudgeType>>(
            `${this.config.getConfiguration().API_BASE}/nudgetype`,
            {},
        );
    }
}
